import * as React from 'react';

import {L10n} from '~commonInfra/L10n/L10n';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { Messages } from '~src/codegen/Localize';
import { DescriptorBlock } from '~src/spacesPlatform/components/DescriptorBlock/DescriptorBlock';
import { cssClass } from '~src/style';

export interface PredictiveModelOverviewSubspaceProps {
  readonly modelName: string;
  readonly modelLastModified: Date;
  readonly modelLastDeployed: Date;
  readonly description: string;
  readonly modelLastTrained: Date;
  readonly deployedVersion: String;
  readonly goal: string;
  readonly outcomeField: string;
  readonly objectiveSuccessValue: string;
  readonly algorithm: string;
  readonly modelType: string;
}

export type PredictiveModelOverviewSubspaceState = {
};

const cssPrefix = 'PredictiveModelOverviewSubspace';
const rowClass = cssClass(cssPrefix, 'topRow', {display: 'flex', flexWrap: 'wrap', paddingLeft: CommonStyles.Sizes.MediumSpace, gap: CommonStyles.Sizes.MediumSpace});

export class PredictiveModelOverviewSubspace extends React.Component<PredictiveModelOverviewSubspaceProps, PredictiveModelOverviewSubspaceState> {
  public render(): JSX.Element {
    const modelLastModified = this.props.modelLastModified ? L10n.localizedDateTime(this.props.modelLastModified) : '';
    const modelLastTrained = this.props.modelLastTrained ? L10n.localizedDateTime(this.props.modelLastTrained) : '';
    const modelLastDeployed = this.props.modelLastDeployed ? L10n.localizedDateTime(this.props.modelLastDeployed) : '';
    return <section>
      <div className={rowClass} >
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ModelName()}
          content={this.props.modelName}/>
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ModelLastModified()}
          content={modelLastModified}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ModelLastDeployed()}
          content={modelLastDeployed}
        />
      </div>
      <div className={rowClass} >
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_Description()}
          content={this.props.description}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ModelLastTrained()}
          content={modelLastTrained}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_DeployedVersion()}
          content={this.props.deployedVersion}
        />
      </div>
      <div className={rowClass} >
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_Goal()}
          content={this.props.goal}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_OutcomeField()}
          content={this.props.outcomeField}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ObjectiveSuccessValue()}
          content={this.props.objectiveSuccessValue}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_Algorithm()}
          content={this.props.algorithm}
        />
        <DescriptorBlock
          title={Messages.predictiveModelOverviewSubspace_ModelType()}
          content={!this.props.modelType ? undefined :
            this.props.modelType === 'Number' ?
              Messages.predictiveModelOverviewSubspace_ModelType_Regression() :
              Messages.predictiveModelOverviewSubspace_ModelType_Binary()
          }
        />
      </div>
    </section>;
  }
}